/**
 *Created by jmmartinez on 20/01/19
 * v.1.1  22/03/2019 Añadido nivel
 * v.1.2  02/04/2019 Añadido CELLTIPO_ENTERO, CELLTIPO_FLOTANTE
 * v.1.3  10/04/2019 Añadido CELLTIPO_SINO, CELLTIPO_LISTA
 *                   Cambio de llamada a CellRenderer para pasar el objeto columna completo.
 * v.1.4  23/04/2019 Añadidos métodos de Pie
 * v.1.5  02/06/2019 Añadidos método de stilo getStyleDeNivelYPie y cambiados los Renderer
 * v.1.6  02/09/2019 Añadida lógica en getValor para FK2N
 * v.1.7  08/11/2019 Añadido CELLTIPO_IMAGENLISTA
 *                   Añadida funcion getCellImagenLista
 * v.1.8  11/11/2019 Exportado método getValor
 *                   Modificado método getValor para tener en cuenta los ForeignJPA
 * v.1.9  10/02/2020 Añadido COLUMNVISIBLE_VARIABLE, COLUMNVISIBLE_SIEMPRE, COLUMNVISIBLE_NUNCA
 * v.1.10 14/02/2020 Añadido CELLTIPO_COLOR y sus métodos de pintado.
 * V.1.11 27/04/2020 Añadido CELLTIPO_ICONO, CELLTIPO_DESCARGAR, CELLTIPO_ELIMINAR
 * v.1.12 24/07/2020 Modificado getValor para devolver un " " cuando el resultado sea null
 * v.1.13 30/08/2020 Añadida llamada a estilizador en getCellCadenaRenderer, getCellFechaRenderer
 * v.2.0   30/09/2020 Cambiado a framework2
 * */

import React from 'react'
import { Cell} from "@blueprintjs/table";
import {getFormattedDateFromTimestamp, getFormattedDateTimeFromTimestamp} from "../ej2/utils/DateUtils";
import {esForeign, esForeign2Nivel, getValorDeForeign, getValorDeForeign2Nivel, esForeignJPA} from "../ej2/utils/ForeignUtils";
import {getValorPropiedad} from "../ej2/utils/ObjectUtils";
import {filtrarConNombreCampo} from "../ej2/utils/FilterUtils";
import {Icon, Intent} from "@blueprintjs/core";
import {
    CELLTIPO_CADENA,
    CELLTIPO_CANTIDAD,
    CELLTIPO_CHORA,
    CELLTIPO_COLOR,
    CELLTIPO_ENTERO,
    CELLTIPO_FECHA,
    CELLTIPO_FECHA_IZQUIERDA,
    CELLTIPO_FECHAHORA,
    CELLTIPO_FLOTANTE,
    CELLTIPO_ICONOACCION,
    CELLTIPO_ICONOACCION_DESCARGAR,
    CELLTIPO_ICONOACCION_ELIMINAR,
    CELLTIPO_ICONOACCION_VER,
    CELLTIPO_IMAGENLISTA,
    CELLTIPO_LISTA,
    CELLTIPO_MONEDA,
    CELLTIPO_PORCENTAJE,
    CELLTIPO_SINO
} from "../ej2/UI/TiposCeldas";


export const getValor= (key, row, datos) => {

    let valorPropiedad= null;
    if (esForeign(key)){
        if (esForeign2Nivel(key)){
            valorPropiedad= getValorDeForeign2Nivel(key, datos[row]);
            if (!valorPropiedad)
                valorPropiedad= " ";
        }
        else {
            valorPropiedad= getValorDeForeign(key, datos[row]);
            if (!valorPropiedad)
                valorPropiedad= " ";
        }
    }
    else {
        if (esForeignJPA(key)){
            valorPropiedad=  getValorPropiedad(datos[row], key);
            if (!valorPropiedad)
                valorPropiedad= " ";
        }
        else {
            valorPropiedad= datos[row][key];
        }
    }
    return valorPropiedad;
}



export const getCellCadenaRenderer= (key, nivel, datos, estilizador) => {
    return (row) => {
        console.log("CADENA");
        let nivelValor = nivel ? datos[row][nivel.campo] : -1;
        let esPie= datos[row].esPie;
        let valor= getValor(key, row, datos);
        let style= getStyleDeNivelYPie(nivelValor, esPie,  CELLTIPO_CADENA);
        if (estilizador) {
            let estiloCalculado = estilizador(datos[row]);
            style= estiloCalculado ? estiloCalculado : style;
        }
        if (valor)
            //return <Cell style={style} onKeyUp={() => {console.log("RR")}} onKeyPress={() => {console.log("KK")}}>{valor}</Cell>;
            return <Cell style={style} >{valor}</Cell>;
        else
            return <Cell style={style}/>;
    }
}


export const getCellFechaRenderer= (key, nivel, datos, estilizador) => {
    return (row) => {
        let style= getStyleDeNivelYPie(-1, false,  CELLTIPO_FECHA);
        if (estilizador) {
            let estiloCalculado = estilizador(datos[row]);
            style= estiloCalculado ? estiloCalculado : style;
        }
        return <Cell style={style}>{getFormattedDateFromTimestamp(datos[row][key])}</Cell>;
    }
}

export const getCellFechaHoraRenderer= (key, nivel, datos) => {
    return (row) => {
        if (datos[row][key])
            return <Cell>{getFormattedDateTimeFromTimestamp(datos[row][key])}</Cell>;
        else
            return <Cell/>
    }

}

export const getCellMonedaRenderer= (key, nivel, datos) => {
    return (row) => {
        let valor= getValor(key, row, datos);
        let esPie= datos[row].esPie;
        let nivelValor = nivel ? datos[row][nivel.campo] : -1;
        let style= getStyleDeNivelYPie(nivelValor, esPie,  CELLTIPO_MONEDA);
        if (valor)
            return <Cell style={style}>{valor + " €"}</Cell>;
        else
            return <Cell style={style}/>
    }
}

export const getCellPorcentajeRenderer= (key, nivel, datos) => {
    return (row) => {
        let valor= getValor(key, row, datos);
        let esPie= datos[row].esPie;
        let nivelValor = nivel ? datos[row][nivel.campo] : -1;
        let style= getStyleDeNivelYPie(nivelValor, esPie, CELLTIPO_PORCENTAJE);
        if (valor)
            return <Cell style={style}>{valor + " %"}</Cell>;
        else
            return <Cell style={style}/>
    }
}

export const getCellCantidadRenderer= (key, nivel, datos) => {
    return (row) => <Cell style={{textAlign:'right'}}>
        {datos[row][key] + " Uds."}
    </Cell>;
}

export const getCellEnteroRenderer= (key, nivel, datos, coloreador, estilizador) => {
    return (row) => {
        let valor= getValor(key, row, datos);
        let esPie= datos[row].esPie;
        let nivelValor = nivel ? datos[row][nivel.campo] : -1;
        let style= getStyleDeNivelYPie(nivelValor, esPie,  CELLTIPO_ENTERO);
        if (estilizador) {
            let estiloCalculado = estilizador(datos[row]);
            style= estiloCalculado ? estiloCalculado : style;
        }

        if (!nivel && !esPie && coloreador) {
            console.log("COLOREADOR");
            style = getStyleDeColoreador(style, coloreador, valor);
        }
        if (valor)
            return <Cell style={style}>{valor}</Cell>;
        else
            return <Cell style={style}/>
    }
}

export const getCellFlotanteRenderer= (key, nivel, datos) => {

    return (row) => {
        let valor= getValor(key, row, datos);
        let esPie= datos[row].esPie;
        let nivelValor = nivel ? datos[row][nivel.campo] : -1;
        let style= getStyleDeNivelYPie(nivelValor, esPie,  CELLTIPO_FLOTANTE);
        if (valor)
            return <Cell style={style}>{valor}</Cell>;
        else
            return <Cell style={style}/>
    }

}

export const getCellSiNoRenderer= (key, nivel, datos) => {
    return (row) => {
        return <Cell style={{textAlign: 'center'}}>
            {datos[row][key] ? "SI" : "NO"}
        </Cell>;
    }
}

export const getCellListaRenderer= (key, lista, nivel, datos) => {
    return (row) => {
        let valorClave = datos[row][key];
        let valorMostrar= "";
        let iconMostrar= "";
        let intentMostrar= Intent.NONE;
        lista.forEach( (elemento) => {
            if (elemento.valor === valorClave){
                valorMostrar= elemento.mensaje;
                iconMostrar= elemento.icono;
                intentMostrar= elemento.intent;
            }
        });

        return <Cell style={{textAlign:'left'}}>
            <>
                <Icon icon={iconMostrar} intent={intentMostrar}/> {valorMostrar}
            </>
        </Cell>;

    }

}

export const getCellCHoraRenderer= (key, nivel, datos) => {
    return (row) => {
        if(datos[row].esPie)
            return <Cell style={{backgroundColor:'#dddddd', fontWeight: 'bold', textAlign: 'right'}}>
                {datos[row][key].horaMinutosDescriptivo}
            </Cell>;
        else
            return <Cell style={{textAlign: 'right'}}>
                {datos[row][key].horaMinutosDescriptivo}
            </Cell>;
    }
}

export const getCellImagenLista= (key, nivel, datos, imagenes, resourcesImages) => {
    return (row) => {
        let valor= getValor(key, row, datos);
        let esPie= datos[row].esPie;
        let nivelValor = nivel ? datos[row][nivel.campo] : -1;
        let style= getStyleDeNivelYPie(nivelValor, esPie,  CELLTIPO_IMAGENLISTA);
        if (valor || typeof valor === 'boolean') {
            let imagenesEncontradas= filtrarConNombreCampo(imagenes, "valor", valor);
            if (imagenesEncontradas && imagenesEncontradas.length > 0) {
                let imagen= "./" + imagenesEncontradas[0].imagen;
                let imagenSrc= resourcesImages(imagen);
                //!Hay que meterlo dentro de un React.Fragment para que no de un warning por una propiedad.
                return  <Cell style={style}>
                    <React.Fragment>
                        <img src={imagenSrc} width={16} alt={valor.toString()}/>
                    </React.Fragment>
                </Cell>;
            }
            else
                return <Cell style={style}>{valor}</Cell>;
        }
        else{
            return <Cell style={style}/>
        }
    }
}

export const getCellColor= (key, nivel, datos) => {
    return (row) => {
        let nivelValor = nivel ? datos[row][nivel.campo] : -1;
        let esPie= datos[row].esPie;
        let valor= getValor(key, row, datos);
        let style= getStyleDeNivelYPie(nivelValor, esPie,  CELLTIPO_CADENA);
        if (!esPie)
            style.backgroundColor= valor;
        if (valor)
            return <Cell style={style} >{valor}</Cell>;
        else
            return <Cell style={style}/>;
    }
}

/*
export const getCellCombo= (key, nivel, datos, itemsLista) => {
    console.log ("getCellCombo: ");
    console.log(itemsLista);
    return (row) => {
        return <div>1</div>
        return <ComboBox
            id= {key}
            fieldText="nombre"
            fieldKey="codigo"
            items={itemsLista}
            filterable={false}
            popoverClassName="popover"
        />
    }
}
*/

export const getCellRenderer= (columna, nivel, datos, resourcesImages) => {
    console.log("GETCELLRENDER");
    let tipo= columna.tipo;
    console.log(tipo);
    let key= columna.campo;
    let coloreador= columna.coloreador;
    let imagenes= columna.imagenes;
    let itemsLista= columna.lista;
    let estilizador= columna.estilizador;
    switch (tipo.toUpperCase()){
        case CELLTIPO_CADENA: return getCellCadenaRenderer(key, nivel, datos, estilizador);
        case CELLTIPO_FECHA:
        case CELLTIPO_FECHA_IZQUIERDA:  return getCellFechaRenderer(key, nivel, datos, estilizador);
        case CELLTIPO_FECHAHORA: return getCellFechaHoraRenderer(key, nivel, datos);
        case CELLTIPO_MONEDA: return getCellMonedaRenderer(key, nivel, datos);
        case CELLTIPO_PORCENTAJE: return getCellPorcentajeRenderer(key, nivel, datos);
        case CELLTIPO_CANTIDAD: return getCellCantidadRenderer(key, nivel, datos);
        case CELLTIPO_ENTERO:
            console.log("ENTERO!!!!")
            return getCellEnteroRenderer(key, nivel, datos, coloreador, estilizador);
        case CELLTIPO_FLOTANTE: return getCellFlotanteRenderer(key, nivel, datos);
        case CELLTIPO_SINO: return getCellSiNoRenderer(key, nivel, datos);
        case CELLTIPO_LISTA: return getCellListaRenderer(key, columna.lista, nivel, datos);
        case CELLTIPO_CHORA: return getCellCHoraRenderer(key, nivel, datos);
        case CELLTIPO_IMAGENLISTA: return getCellImagenLista(key, nivel, datos, imagenes, resourcesImages);
        case CELLTIPO_COLOR: return getCellColor(key, nivel, datos);
        //case CELLTIPO_COMBO: return getCellCombo(key, nivel, datos, itemsLista);
        default: return getCellCadenaRenderer(key, nivel, datos);
    }
}

export const getStyleDeNivel= (nivel, tipo) => {

    let style = {
        textAlign: 'left',
        backgroundColor: '#ffffff'
    }
    switch (tipo.toUpperCase()){
        case 'CELLTIPO_CADENA':
        case 'CELLTIPO_LISTA': style.textAlign= 'left'; break;
        case 'CELLTIPO_FECHA':
        case 'CELLTIPO_FECHA_IZQUIERDA':
        case 'CELLTIPO_FECHAHORA':
        case 'CELLTIPO_CHORA':
        case 'CELLTIPO_COLOR':
        case 'CELLTIPO_SINO':
        case 'CELLTIPO_BOOLEANO': style.textAlign= 'center'; break;
        case 'CELLTIPO_CANTIDAD':
        case 'CELLTIPO_MONEDA':
        case 'CELLTIPO_PORCENTAJE':
        case 'CELLTIPO_ENTERO':
        case 'CELLTIPO_FLOTANTE': style.textAlign= 'right'; break;
        default: break;
    }

    if (nivel >= 0) {
        if (nivel === "1") {
            style.backgroundColor = '#aaaaaa';
            style.fontWeight= 'bolder';
        }
        if (nivel === "2") {
            style.backgroundColor = '#dddddd';
            style.fontWeight= 'bold';
        }
    }
    return style;
}

export const getStyleDeNivelYPie= (nivel, esPie, tipo) => {

    let style = {
        textAlign: 'left',
        backgroundColor: '#ffffff'
    }
    if (esPie){
        style= {
            backgroundColor: '#dddddd',
            fontWeight: 'bold',
            textAlign: 'right'
        }
    }
    switch (tipo.toUpperCase()){
        case 'CELLTIPO_CADENA':
        case 'CELLTIPO_LISTA': style.textAlign= 'left'; break;
        case 'CELLTIPO_FECHA':
        case 'CELLTIPO_FECHA_IZQUIERDA':
        case 'CELLTIPO_FECHAHORA':
        case 'CELLTIPO_CHORA':
        case 'CELLTIPO_SINO':
        case 'CELLTIPO_COLOR':
        case 'CELLTIPO_BOOLEANO': style.textAlign= 'center'; break;
        case 'CELLTIPO_CANTIDAD':
        case 'CELLTIPO_MONEDA':
        case 'CELLTIPO_PORCENTAJE':
        case 'CELLTIPO_ENTERO':
        case 'CELLTIPO_FLOTANTE': style.textAlign= 'right'; break;
        case CELLTIPO_IMAGENLISTA: style.textAlign= 'center';
                                   style.paddingTop= 2;
                                   style.paddingBottom= 2;
                                   break;
        default: break;
    }

    if (nivel >= 0) {
        if (nivel === "1") {
            style.backgroundColor = '#aaaaaa';
            style.fontWeight= 'bolder';
        }
        if (nivel === "2") {
            style.backgroundColor = '#dddddd';
            style.fontWeight= 'bold';
        }
    }
    return style;
}

export const getStyleDeColoreador= (styleOriginal, coloreador, valor) => {
    let style = {...styleOriginal};

    if (valor <= coloreador.valorUmbral1)
        style.backgroundColor= coloreador.color1;
    else
        style.backgroundColor= coloreador.color2;

    return style;
}